import CajuCultura from "../Components/Castanha/CajuCultura/CajuCultura";
import HistoriaCastanha from "../Components/Castanha/HistoriaCastanha/HistoriaCastanha";
import Cajueiros from "../Components/Castanha/Cajueiros/Cajueiros";
import CuriosidadeCastanha from "../Components/Castanha/CuriosidadeCastanha/CuriosidadeCastanha";

export default function Castanha() {
  return (
    <div>
      <HistoriaCastanha />
      <CuriosidadeCastanha />
      <CajuCultura />
      <Cajueiros />
    </div>
  );
}
